import React from 'react'
import { config } from '../../config/config'

const Modal = () => {
    return (
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white/90 shadow-xl py-12 px-16 z-[99999] text-2xl rounded-md">
            { config.content.modal.location_warning.heading }
        </div>
    )
}

export default Modal
